/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterState } from './barterState.model';
import { ContractState } from './contractState.model';


export interface PaymentGroupItemDto { 
    amount: number;
    barterId?: number;
    barterNumber?: string;
    barterState?: BarterState;
    contractId?: number;
    contractOfficialNumber?: string;
    contractState?: ContractState;
    id?: number;
    note?: string;
    paymentInfo?: Array<string>;
    /**
     * Date and time the payment was sent.
     */
    paymentStatusCheck?: string;
    returnedDate?: string;
    sendDate?: string;
    specificSymbol?: string;
    variableSymbol?: string;
}
export namespace PaymentGroupItemDto {
}


